const initializeDialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  allDialogs.forEach( (dialog) => {
    dialog.addEventListener( 'click', function (event) {
      const rect = dialog.getBoundingClientRect();
      const isInDialog = (
        rect.top <= event.clientY
        && event.clientY <= rect.top + rect.height
        && rect.left <= event.clientX
        && event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) {
        dialog.close();
      }
    } );
  } );

  openDialogButtons.forEach( (dialogButton) => {
    const dialogToShow = dialogButton.dataset.openDialog;

    if (!dialogToShow) {
      return;
    }

    const dialog = document.querySelector( `[data-dialog="${CSS.escape( dialogToShow )}"]` );

    dialogButton.addEventListener( 'click', event => {
      dialog.showModal();
    } );
  } );

  closeDialogButtons.forEach( (dialogButton) => {
    const dialogToClose = dialogButton.dataset.closeDialog;

    if (!dialogToClose) {
      return;
    }

    const dialog = document.querySelector( `[data-dialog="${CSS.escape( dialogToClose )}"]` );

    dialogButton.addEventListener( 'click', event => {
      dialog.close();
    } );
  } );
};

const dialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  if (!openDialogButtons || !closeDialogButtons) {
    return;
  }

  initializeDialogs( openDialogButtons, closeDialogButtons, allDialogs );
};

export default dialogs;